<template>
	<div class="filelibrarydetail">
		<headerview :cur="4"></headerview>
		<div class="content">
			<div class="moddlecon w13">
				<div class="tipcon">
					
					<tipconNav :title="'标准队课'" :name="[{label:'标准队课',url:'/excellentcases'},{label:'详情',url:''}]" :imgtype="'2'" width="2.03"></tipconNav>
				</div>

				<div class="box">
					<videobox v-if='informdata.videoId_dictText' :file="$fileAccessHttpUrl(informdata.videoId_dictText)" numH='420px'></videobox>
				</div>
				<div class="min-h mb">
					<div class="f-row-l">
						<div class="btn f-row-c" :class="act==0?'actbtn':''" @click="onTab(0)">课程详情</div>
						<div class="btn f-row-c" :class="act==1?'actbtn':''" @click="onTab(1)">课件资源</div>
					</div>
					<div class="cont">
						<div v-if='act==0'>
							<div class="tit">{{informdata.title||''}}</div>
							<div class="htmlbox">
								<div v-html="informdata.content"></div>
							</div>
							
						</div>
						<div v-if='act==1' class="itemlist">
							<div v-for="(item,ind) in list" :key='ind' class="item f-row-b wrap">
								<div class="f-row-start-l wrap">
									<el-image fit='conver' class="iconfile" :src='imgFile'></el-image>
									<div class="item-r">
										<div class="item-tit" v-if='item.fileName'>
											{{item.fileName||''}}
										</div>
										<div class="item-tit" v-else>
											{{item.fileId_dictText?item.fileId_dictText.split('_')[0].replace('temp/',''):''}}
										</div>
										<div class="item-size">文件大小：{{item.fileSize?Number(item.fileSize/(1024*1024)).toFixed(2):0}}M</div>
									</div>
								</div>
								<div class="down-btn f-row-c" @click="downloadFile(item)">
									<el-image fit='conver' class="iconimg" :src='imgDown'></el-image>
									<div class="ml">下载</div>
								</div>
							</div>
							<div v-if='list.length==0' class="f-row-c mt-3">
								暂无数据
							</div>
							<!-- 分页 -->
							<div class="" v-if='total'>
								<div is='footPage' class="zhini-pagination"
								:currentPage="pageNo"
								:totalPage="total"
								@pageNum="pageNum"  :pagesize='pageSize'></div>
							</div>
						</div>
					</div>
				</div>
				
			</div>	
		</div>
		
		<footview></footview>
		
	</div>
	
</template>

<script>

import videobox from '../../../com/videobox.vue'
import footPage from '../../../components/footpage/footpage.vue'
export default {
  components: {
	  videobox,
	  footPage
  },
  data: function() {
    return {
		imgDown:require("../../../static/img/img_down.png"),
		imgFile:require("../../../static/img/img_file.png"),
		type:'1',
		act:0,
		informdata:{
			// title:"标题名称标题名称标题名称",
			// source:"来源来着",
			// datetime:"2021-01-01 13:12:00",
			// contentval:"文本内容文本内容文本内容文本内容文本内容"
		},
		id:"",
	  	list:[],
		pageNo:1,
		total:5,
		pageSize:5,
    };
  },
  created(){ 
	if(this.$route.query) {
		this.type = this.$route.query.type;
		this.id = this.$route.query.id;
	}
	
	this.getCulturalDetail()
  },
  mounted() {
		this.$onScrollT()
		
  },

  methods: {
		downloadFile(item) {
			window.open(this.$fileAccessHttpUrl(item.fileId_dictText))
		},
	  	pageNum(e) {
			this.pageNo = e;
			this.$onScrollT()
			this.getList()
		},
	  	onTab(e){
			this.act=e 
			if(e==1) { 
				this.pageNo=1;
				this.getList()
			}
		},
		getList(){
			var params={ 
				pageSize:this.pageSize,
				pageNo:this.pageNo,
				caseId:this.id
			}
			this.$get('web/culturalproduct/resourceList',params).then(res=>{
				if(res.success){
					this.total = res.result.total
					this.list = res.result.records;
				}
			})
		},
	    //文件库
	    getCulturalDetail(){
	    	this.$get(`web/culturalproduct/queryDataById?id=${this.id}`).then(res=>{
	    		  if(res.success){
					  this.informdata=res.result;		
	    		  }
	    	})
	    },
  },
  
  
};
</script>

<style scoped="scoped" lang="scss">
	
.filelibrarydetail{
	
	.content{
		display: flex;
		justify-content: center;
		.moddlecon{
			background-color: #FFFFFF;
    		padding: 20px 50px 0px 50px;
			box-sizing: border-box;
			.box{
				width: 720px;
				margin:57px auto 60px;
			}
			.btn,.actbtn{
				width: 118px;
				height: 42px;
				border-radius: 8px;
				background: #EEEEEE;
				color: #333333;
				margin-right: 20px;
				font-size: 18px;
			}
			.actbtn{ 
				background: #E61F26;
				color: #ffffff;
			}
			.mb{
				margin-bottom: 50px;
			}
			.cont{
				
				.tit{
					margin-top: 50px;
					font-size: 24px;
					font-weight: 400;
					color: #333333;
					margin-bottom: 33px;
				}
				.htmlbox{
					font-size: 19px!important;
					font-weight: 400!important;
					color: #666666!important;
					line-height: 40px!important;
				}
				.itemlist{
					margin-top: 10px;
				}
				.item{
					padding:39px 0px;
					border-bottom: 1px dashed #CCCCCC;
					.iconfile{
						width: 72px;
						height: 72px;
					}
					.iconimg{
						width: 21px;
						height: 20px;
					}
					.item-r{
						margin-left: 20px;
						font-weight: 400;
						.item-tit{
							font-size: 24px;
							color: #333333;
							line-height: 35px;
						}
						.item-size{
							margin-top: 10px;
							font-size: 16px;
							color: #666666;
						}
					}
					.down-btn{
						min-width: 159px;
						height: 55px;
						background: #E61F26;
						border-radius: 10px;
						color: #ffffff;
						cursor:pointer;
						.ml{
							margin-left: 8px;
							font-size: 24px;
						}
					}
				}
			}
		}
			
	}
			
	
	
}

</style>
<style scoped>
/deep/ .htmlbox img{
	max-width: 100%;
	vertical-align: middle
}
</style>
